export default __webpack_public_path__ + "static/media/hands-effect.f222cbfe.mp4";